import type {CreateExtArgs} from '@wix/document-manager-core'
import type {ComponentBeforeAddDataEvent} from '../hooks'
import {getComponentType} from '../../../utils/dalUtils'
import _ from 'lodash'
import type {Pointer} from '@wix/document-services-types'

export const makeSureOnlyOnSiteRegionContainer = (createExtArgs: CreateExtArgs, data: ComponentBeforeAddDataEvent) => {
    const {pointers, dal} = createExtArgs
    const {containerPointer, componentDefinition} = data
    const children = pointers.structure.getChildren(containerPointer)

    function isSameCompType(child: Pointer) {
        return getComponentType(dal, child) === componentDefinition.componentType
    }

    if (_.find(children, isSameCompType)) {
        throw new Error('Only one SiteRegionContainer allowed')
    }
}
